import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupinfoComponent } from './groupinfo/groupinfo.component';
import { NgbCarouselModule, NgbModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { CartComponent } from './cart/cart.component';
import { OrderdetailsComponent } from './orderdetails/orderdetails.component';
import { OrderaddressComponent } from './orderaddress/orderaddress.component';
import { OrderaddresseditComponent } from './orderaddressedit/orderaddressedit.component';
import { ReactiveFormsModule } from '@angular/forms';
import { OrderinvoiceaddressComponent } from './orderinvoiceaddress/orderinvoiceaddress.component';
import { OrderComponent } from './order/order.component';
import { OrdersComponent } from './orders/orders.component';
import { CurrentorderComponent } from './currentorder/currentorder.component';
import { OrdercompletedComponent } from './ordercompleted/ordercompleted.component';
import { PickupofficeComponent } from './pickupoffice/pickupoffice.component';
import { BasecartComponent } from './basecart/basecart.component';
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatOption, MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatBadgeModule } from '@angular/material/badge';
import {AppCommonModule} from "../common/common.module";



@NgModule({
  declarations: [
    GroupinfoComponent,
    CartComponent,
    OrderdetailsComponent,
    OrderaddressComponent,
    OrderaddresseditComponent,
    OrderinvoiceaddressComponent,
    OrderComponent,
    OrdersComponent,
    CurrentorderComponent,
    OrdercompletedComponent,
    PickupofficeComponent,
    BasecartComponent
  ],
  imports: [
    CommonModule,
    NgbCarouselModule,
    ReactiveFormsModule,
    NgbTypeaheadModule,
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
    MatBadgeModule,
    AppCommonModule
  ]
})
export class OrderModule { }
